import React from 'react';
import './GooglePlayBadge.css';

const GooglePlayBadge = ({ 
  href, 
  size = 'standard', 
  language = 'en',
  className = '',
  ariaLabel = 'Get it on Google Play'
}) => {
  // Official Google Play badge images following Google's guidelines
  const getBadgeImage = () => {
    const sizeMap = {
      'small': { width: 135, height: 40 },
      'standard': { width: 200, height: 60 },
      'large': { width: 270, height: 80 }
    };
    
    const dimensions = sizeMap[size] || sizeMap.standard;
    
    // Using official Google Play badge images from Google's CDN
    // These are the official badges provided by Google
    const badgeUrls = {
      'small': 'https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png',
      'standard': 'https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png',
      'large': 'https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'
    };
    
    return (
      <img 
        src={badgeUrls[size] || badgeUrls.standard}
        alt="Get it on Google Play"
        width={dimensions.width}
        height={dimensions.height}
        className="google-play-badge-img"
        style={{
          width: dimensions.width,
          height: dimensions.height,
          objectFit: 'contain'
        }}
        onError={(e) => {
          // Fallback to a simple text button if image fails
          e.target.style.display = 'none';
          e.target.parentElement.innerHTML = '<div style="background: #000; color: #fff; padding: 10px 20px; border-radius: 8px; text-align: center; font-family: Roboto, Arial, sans-serif; font-size: 14px; font-weight: 500;">Get it on Google Play</div>';
        }}
      />
    );
  };

  return (
    <a 
      href={href}
      className={`google-play-badge badge-${size} ${className}`}
      aria-label={ariaLabel}
      target="_blank"
      rel="noopener noreferrer"
    >
      {getBadgeImage()}
    </a>
  );
};

export default GooglePlayBadge;